import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getJwtToken } from 'utils/functions/session-storage';
import { HOST } from 'variables';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: HOST,
  prepareHeaders: (headers) => {
    const token = getJwtToken();
    if (token) {
      headers.set('Authorization', `${token}`);
    }
    return headers;
  }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error) {
    const { status, data } = result.error;

    // Handle 401 Unauthorized
    if (status === 401) {
      console.error('Unauthorized access - 401. Throwing user out.');
      // api.dispatch({ type: 'user/logout' });
      // "Properly" throw the user out by forcing a redirect to login
      // if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
      //   window.location.reload(); // Reloading will hit the auth protection and send them to /login
      // }
    }

    // Global error logging
    console.error(`API Error [${status}]:`, data || result.error);
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Program',
    'Programs',
    'ProgramTypes',
    'Employee',
    'Employees',
    'AssignedEmployees',
    'UnassignedEmployees',
    'PlanEmployees',
    'EmployeeEnrollments',
    'EmployeeClaimAnalytics',
    'BenefPurchaseList',
    'Offer',
    'Offers',
    'Event',
    'Events',
    'Order',
    'Orders',
    'Settlement',
    'Settlements',
    'Category',
    'Categories',
    'Merchant',
    'Merchants',
    'Organization',
    'Organizations',
    'License',
    'Licenses',
    'Sponsor',
    'Sponsors',
    'Item',
    'Items',
    'Tag',
    'Tags',
    'ItemCategory',
    'ItemCategories',
    'Charge',
    'Charges',
    'Store',
    'Stores',
    'Catalogue',
    'Catalogues',
    'Receivable',
    'Receivables',
    'Bundle',
    'Bundles',
    'Account',
    'Accounts',
    'BusinessType',
    'BusinessTypes',
    'Device',
    'Devices',
    'PublicAuth',
    'PublicOffer',
    'PublicOffers',
    'AppUser',
    'AppUsers',
    'MediaEvent',
    'MediaEvents',
    'Terminal',
    'Terminals',
    'Operator',
    'Operators',
    'Chapter',
    'Chapters',
    'Display',
    'Displays',
    'Runbook',
    'Runbooks',
    'Contracts',
    'MediaEventsStats',
    'TerminalsStats',
    'OperatorsStats',
    'ChaptersStats',
    'RunbooksStats',
    'RecentActivity'
  ],
  endpoints: () => ({})
});
